// Copyright (c) 2016 Deere & Company

import classNames from '../../shared/constants/ag-grid-class-names';
import {translate} from '../../../shared/services/translation-service';

export function getQuestionablePartColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'material',
            field: 'material',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('MATERIAL'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'language',
            field: 'language',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('LANGUAGE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'prodhierarchy',
            field: 'prodhierarchy',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PRODUCT_HIERARCHY'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'modelnumber',
            field: 'modelnumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('MODEL_NUMBER'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'branch',
            field: 'branch',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('BRANCH'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'wtyClmType',
            field: 'wtyClmType',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('WARRANTY_CLAIM_TYPE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'masterWarrantytype',
            field: 'masterWarrantytype',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('MASTER_WARRANTY_TYPE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'questDesc',
            field: 'questDesc',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('QUEST_DESC'),
            width: 200
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/questionable-part-search/report-services/column-definitions.js